import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router";

import FloatingActionButtonSize from "./components/FloatingButton";

import App from "./App";

import AddClientPage from "./admin/pages/AddClientPage";
import EditClientPage from "./admin/pages/EditClientPage";
import AddDriverPage from "./admin/pages/AddDriverPage";
import AddVehiclePage from "./admin/pages/AddVehiclePage";
import EditVehiclePage from "./admin/pages/EditVehiclePage";
import EditDriverPage from "./admin/pages/EditDriverPage";

import ClientsPage from "./admin/pages/ClientsPage";
import SettingsPage from "./admin/pages/SettingsPage";
import DriversPage from "./admin/pages/DriversPage";
import VehiclesPage from "./admin/pages/VehiclesPage";
import ClientBookingsPage from "./admin/pages/ClientBookingsPage";
import UpcomingBookingsPage from "./admin/pages/UpcomingBookingsPage";
import PastBookingsPage from "./admin/pages/PastBookingsPage";
import MenuPage from "./admin/pages/MenuPage";
import AdminLayout from "./admin/layouts/AdminLayout";
import PricingLayout from "./admin/layouts/PricingLayout";
import PricingPage from "./admin/pages/pricing/PricingPage";
import PricingEntityFormPage from "./admin/pages/pricing/PricingEntityFormPage";

import ProtectedRoute from "./utils/ProtectedRoute";
import LoadingScreen from "./utils/LoadingScreen";

import VoucherPage from "./pages/Voucher";
import CheckinPage from "./pages/CheckinPage";

import AuthenticatePage from "./auth";

const QuotePage = lazy(() => import("./pages/QuotePage"));

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="authenticate" element={<AuthenticatePage />} />
        {/*  Protected Route Start */}
        <Route path="admin-management" element={<ProtectedRoute />}>
          <Route
            index
            element={<Navigate to="/admin-management/upcoming" replace />}
          />
          <Route element={<AdminLayout />}>
            <Route path="upcoming" element={<UpcomingBookingsPage />} />
            <Route path="past" element={<PastBookingsPage />} />
            <Route path="menu" element={<MenuPage />} />
          </Route>

          <Route path="add" element={<AddClientPage />} />
          <Route path="others">
            <Route path="clients">
              <Route index element={<ClientsPage />} />
              <Route path=":phone" element={<ClientBookingsPage />} />
            </Route>
            <Route path="settings" element={<SettingsPage />} />
            <Route path="drivers">
              <Route index element={<DriversPage />} />
              <Route path="add" element={<AddDriverPage />} />
              <Route path="edit">
                <Route path=":id" element={<EditDriverPage />} />
              </Route>
            </Route>
            <Route path="vehicles">
              <Route index element={<VehiclesPage />} />
              <Route path="add" element={<AddVehiclePage />} />
              <Route path="edit">
                <Route path=":id" element={<EditVehiclePage />} />
              </Route>
            </Route>
            <Route path="pricing" element={<PricingLayout />}>
              <Route index element={<PricingPage />} />
              <Route path=":entity/add" element={<PricingEntityFormPage />} />
              <Route path=":entity/edit/:id" element={<PricingEntityFormPage />} />
            </Route>
          </Route>
          <Route path="edit">
            <Route index path=":id" element={<EditClientPage />} />
          </Route>
        </Route>
        {/*  Protected Route End */}
        <Route
          path="orcamento"
          element={
            <Suspense fallback={<LoadingScreen />}>
              <QuotePage />
            </Suspense>
          }
        />
        <Route path="voucher">
          <Route index path=":id" element={<VoucherPage />} />
        </Route>
        <Route path="checkin">
          <Route index path=":id" element={<CheckinPage />} />
        </Route>
        {/* Catch-all route must be last */}
        <Route
          path="*"
          element={
            <>
              <FloatingActionButtonSize />
              <App />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
